import { Table } from "../../components/ui/table";
import { useEffect, useState } from "react";
import ViewIcon from "../../components/icons/view-icon";
import ConfirmationCard from "../../components/ui/confirmation-card";
import Modal from "../../components/ui/modal";
import CardDetail from "../../components/cardDetail/cardDetail";
import {
  getCardDetail,
  getCards,
  getCardsCount,
  getProcessingTeam,
} from "src/firebase/admin.js";
import Button from "../../components/button";
import Popover from "@mui/material/Popover";
import Input from "../../components/input";
import { deleteDoc, doc, setDoc } from "firebase/firestore";
import { db } from "src/firebase/firebase";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import {} from "firebase/firestore";
import { handleToastMessage } from "src/js/handleToastMessage";
import { dateSorting } from "src/js/sorting";
import editIcon from "../../assets/images/editing.png";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { Pagination } from "@mui/material";
import OverlayLoader from "../../components/overlayLoader";

const pageSize = 200;

const CardRequest = () => {
  const [activeDeletedId, setActiveDeletedId] = useState<string>("");
  const [totalCards, setTotalCards] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [cardList, setCardList] = useState([]);
  const [filterCardList, setFilterCardList] = useState([]);
  const [activeCardDetail, setActiveCardDetail] = useState(null);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [searchtext, setSearchText] = useState<string>("");
  const [processingTeamList, setProcessingTeamList] = useState([]);
  const [filterProcessingTeamList, setFilterrocessingTeamList] = useState([]);
  const { t } = useTranslation(["home"]);
  const navigate = useNavigate();

  useEffect(() => {
    getProcessingTeamList();
  }, []);

  const getProcessingTeamList = async () => {
    let result = await getProcessingTeam();
    result = result.map((item) => {
      return {
        ...item,
        id: item?.id,
        userName: `${item.firstName} ${item.lastName}`,
        email: item.email,
      };
    });
    setProcessingTeamList(result);
    setFilterrocessingTeamList(result);
  };
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    getCardListCount();
  }, []);

  useEffect(() => {
    getCardList();
  }, [currentPage, searchtext]);
  const getCardListCount = async () => {
    let result: any = await getCardsCount();

    console.log("result", result);
    setTotalCards(result);
  };

  const getCardList = async () => {
    setIsLoading(true);
    let result: any = await getCards("", "", currentPage, pageSize, searchtext);
    console.log(result)
    setIsLoading(false);
    result = result.map((item) => {
      return {
        ...item,
        id: item?.id,
        name: item?.account?.firstName + " " + item?.account?.lastName,
        cardNo: item?.cardNo,
        cvv: item?.cvv,
        mmyy: item?.mmyy ?? "",
        amount: item?.amount,
        rate: item?.rate,
        status: item?.status ?? "",
      };
    });
    let _cardList = dateSorting(result ?? [], "date");
    setCardList(_cardList);
    setFilterCardList(_cardList);
  };

  const updateAssignee = async (assigne, data) => {
    let _data = data;
    _data.assignee = assigne;
    let _detail = await getCardDetail(_data.id);
    if (_detail.length > 0) {
      if (_detail[0]?.assignee) {
        handleToastMessage("error", "Card is already assigned.");
      } else {
        await setDoc(doc(db, "Cards", _data.id), _data);
        await getCardList();
      }
      handleClose();
    }
  };

  const handleSearch = (value) => {
    const filteredValue = value.toLowerCase();
    const _filterData = processingTeamList.filter((value: any) => {
      let name = `${value?.firstName?.toLowerCase()} ${value?.lastName?.toLowerCase()}`;
      return name.includes(filteredValue);
    });
    setFilterrocessingTeamList([..._filterData]);
  };

  const handleCardSearch = (value) => {
    setSearchText(value);
    setCurrentPage(1);
  };
  const handleDelete = () => {
    const docRef = doc(db, "Cards", activeDeletedId);
    deleteDoc(docRef).then((res) => {
      handleToastMessage("success", "Delete card successfully");
      setActiveDeletedId("");
      getCardList();
    });
  };

  const columns = [
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("ID")}</span>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("User Name")}</span>
        </div>
      ),
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (name: string) => <div>{name}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Card No")}</span>
        </div>
      ),
      dataIndex: "cardNo",
      key: "cardNo",
      width: 200,
      render: (cardNo: string) => <div>{cardNo}</div>,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Cvv")}</span>
        </div>
      ),
      dataIndex: "cvv",
      key: "cvv",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("MM/YY")}</span>
        </div>
      ),
      dataIndex: "mmyy",
      key: "mmyy",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Amount")}</span>
        </div>
      ),
      dataIndex: "amount",
      key: "amount",
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Rate")}</span>
        </div>
      ),
      dataIndex: "rate",
      key: "rate",
      width: 200,
    },
        {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Order")}</span>
        </div>
      ),
      dataIndex: "order",
      key: "order",
      width: 200,
    },

    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Date")} </span>
        </div>
      ),
      key: "date",
      dataIndex: "date",
      render: (date: any) => (
        <div>{date ? new Date(date.seconds * 1000).toDateString() : ""}</div>
      ),
      width: 200,
    },
    {
      title: (
        <div className="pl-1 flex justify-between items-center">
          <span>{t("Action")}</span>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      width: 350,
      render: (assignee: any, row: any) => (
        <div className="flex gap-x-2">
          {row.assignee && (
            <div className="flex gap-x-2 items-center">
              <div className="py-2 px-5 bg-green text-white rounded">
                {t("Assigned")}{" "}
              </div>
              <ViewIcon
                className="cursor-pointer"
                onClick={() => setActiveCardDetail(row)}
              />
            </div>
          )}
          {!row.assignee && (
            <div className="flex gap-x-2 items-center">
              <ViewIcon
                className="cursor-pointer"
                onClick={() => setActiveCardDetail(row)}
              />
              <Button
                className="cursor-pointer"
                size="small"
                onClick={handleClick}
              >
                {t("Assign to")}
              </Button>

              <Popover
                id={"id"}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                style={{ marginTop: "5px" }}
              >
                <div className="shadow p-2 bg-white w-[250px] h-[300px] overflow-y-scroll">
                  <Input
                    name="search"
                    placeholder="Search"
                    className="mb-3"
                    onChange={(e) => handleSearch(e.target.value)}
                  />

                  {filterProcessingTeamList.map((item) => (
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-sm">{`${item.firstName} ${item.lastName}`}</span>
                      <Button
                        size="small"
                        onClick={() => updateAssignee(item, row)}
                      >
                        {t("Assign")}
                      </Button>
                    </div>
                  ))}
                </div>
              </Popover>
            </div>
          )}
          <Button
            size="small"
            className="bg-red"
            onClick={() => setActiveDeletedId(row.id)}
          >
            {t("Delete")}
          </Button>
          {/* <img
            src={editIcon}
            className="cursor-pointer"
            onClick={() => navigate(`/supplier/new-card?id=${row.id}`)}
          /> */}
        </div>
      ),
    },
  ];

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
  };
  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Cards")} {t("Management")}
        </h2>
      </div>
      <div className="p-4 bg-white">
        <div className="flex justify-between items-center mb-3">
          <h1 className="text-darkGrey text-lg font-bold ">
            {t("Cards")} {t("List")}
          </h1>

          <Input
            name="search"
            placeholder="Search card"
            className="mb-3"
            onChange={(e) => handleCardSearch(e.target.value)}
          />
        </div>
        {isLoading && <OverlayLoader />}
        <Table
          tableLayout="fixed"
          columns={columns as any}
          emptyText="No data found"
          data={filterCardList}
          rowKey="id"
          scroll={{ x: 1000 }}
          sticky={true}
          className="matrix"
          onHeaderRow={() => ({
            className: "header-title",
          })}
        />
        <Pagination
          className="w-full mt-10"
          page={currentPage}
          count={Math.ceil(totalCards / pageSize)}
          onChange={handlePageChange}
        />
      </div>
      <Modal
        open={activeDeletedId ? true : false}
        onClose={() => setActiveDeletedId("")}
      >
        <ConfirmationCard
          title="Delete This Item?"
          onCancel={() => setActiveDeletedId("")}
          onDelete={handleDelete}
          description="Are you sure about deleting this card? This cannot be undone."
        />
      </Modal>
      <Modal
        open={activeCardDetail ? true : false}
        onClose={() => setActiveCardDetail(null)}
        modalClass="w-full"
      >
        <CardDetail detail={activeCardDetail} isAdmin={true} />
      </Modal>
    </div>
  );
};
export default CardRequest;
